<div class="s__insights-cta" [class.s__insights-cta--inline]="placement() === 'inline'">
  @if (heading()) {
    <h2 class="s__insights-cta__heading">{{ heading() }}</h2>
  }
  @if (body()) {
    <p class="s__insights-cta__body">{{ body() }}</p>
  }
  <a [href]="buttonHref()" class="s__insights-cta__action">
    <ds-button variant="primary">{{ buttonLabel() }}</ds-button>
  </a>
</div>
